/* tslint:disable */
/* eslint-disable */
/**
 * Assemblean Production Solutions
 * Produce the lean way with APCS
 *
 * The version of the OpenAPI document: 0.9.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  APIContactGroupCreation,
  APIContactGroupCreationRequest,
  APIContactGroupView,
  APIContactGroupViewRequest,
  APIPaginatedContactGroupViewList,
  APIPatchedContactGroupViewRequest,
} from '../models/index';
import {
    APIContactGroupCreationFromJSON,
    APIContactGroupCreationToJSON,
    APIContactGroupCreationRequestFromJSON,
    APIContactGroupCreationRequestToJSON,
    APIContactGroupViewFromJSON,
    APIContactGroupViewToJSON,
    APIContactGroupViewRequestFromJSON,
    APIContactGroupViewRequestToJSON,
    APIPaginatedContactGroupViewListFromJSON,
    APIPaginatedContactGroupViewListToJSON,
    APIPatchedContactGroupViewRequestFromJSON,
    APIPatchedContactGroupViewRequestToJSON,
} from '../models/index';

export interface V1ContactsContactGroupsCreateRequest {
    aPIContactGroupCreationRequest: APIContactGroupCreationRequest;
}

export interface V1ContactsContactGroupsDestroyRequest {
    id: number;
}

export interface V1ContactsContactGroupsListRequest {
    page?: number;
    pageSize?: number;
}

export interface V1ContactsContactGroupsPartialUpdateRequest {
    id: number;
    aPIPatchedContactGroupViewRequest?: APIPatchedContactGroupViewRequest;
}

export interface V1ContactsContactGroupsRetrieveRequest {
    id: number;
}

export interface V1ContactsContactGroupsUpdateRequest {
    id: number;
    aPIContactGroupViewRequest: APIContactGroupViewRequest;
}

export interface V1ContactsContactsGroupsCreateRequest {
    contactsPk: string;
    aPIContactGroupCreationRequest: APIContactGroupCreationRequest;
}

export interface V1ContactsContactsGroupsDestroyRequest {
    contactsPk: string;
    id: number;
}

export interface V1ContactsContactsGroupsListRequest {
    contactsPk: string;
    page?: number;
    pageSize?: number;
}

export interface V1ContactsContactsGroupsPartialUpdateRequest {
    contactsPk: string;
    id: number;
    aPIPatchedContactGroupViewRequest?: APIPatchedContactGroupViewRequest;
}

export interface V1ContactsContactsGroupsRetrieveRequest {
    contactsPk: string;
    id: number;
}

export interface V1ContactsContactsGroupsUpdateRequest {
    contactsPk: string;
    id: number;
    aPIContactGroupViewRequest: APIContactGroupViewRequest;
}

/**
 * 
 */
export class ContactscontactgroupApi extends runtime.BaseAPI {

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsCreateRaw(requestParameters: V1ContactsContactGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupCreation>> {
        if (requestParameters['aPIContactGroupCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIContactGroupCreationRequest',
                'Required parameter "aPIContactGroupCreationRequest" was null or undefined when calling v1ContactsContactGroupsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contact_groups/`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIContactGroupCreationRequestToJSON(requestParameters['aPIContactGroupCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupCreationFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsCreate(requestParameters: V1ContactsContactGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupCreation> {
        const response = await this.v1ContactsContactGroupsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsDestroyRaw(requestParameters: V1ContactsContactGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactGroupsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contact_groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsDestroy(requestParameters: V1ContactsContactGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ContactsContactGroupsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsListRaw(requestParameters: V1ContactsContactGroupsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedContactGroupViewList>> {
        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contact_groups/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedContactGroupViewListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsList(requestParameters: V1ContactsContactGroupsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedContactGroupViewList> {
        const response = await this.v1ContactsContactGroupsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsPartialUpdateRaw(requestParameters: V1ContactsContactGroupsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupView>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactGroupsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contact_groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedContactGroupViewRequestToJSON(requestParameters['aPIPatchedContactGroupViewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupViewFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsPartialUpdate(requestParameters: V1ContactsContactGroupsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupView> {
        const response = await this.v1ContactsContactGroupsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsRetrieveRaw(requestParameters: V1ContactsContactGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupView>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactGroupsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contact_groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupViewFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsRetrieve(requestParameters: V1ContactsContactGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupView> {
        const response = await this.v1ContactsContactGroupsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsUpdateRaw(requestParameters: V1ContactsContactGroupsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupView>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactGroupsUpdate().'
            );
        }

        if (requestParameters['aPIContactGroupViewRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIContactGroupViewRequest',
                'Required parameter "aPIContactGroupViewRequest" was null or undefined when calling v1ContactsContactGroupsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contact_groups/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIContactGroupViewRequestToJSON(requestParameters['aPIContactGroupViewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupViewFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactGroupsUpdate(requestParameters: V1ContactsContactGroupsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupView> {
        const response = await this.v1ContactsContactGroupsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsCreateRaw(requestParameters: V1ContactsContactsGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupCreation>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsGroupsCreate().'
            );
        }

        if (requestParameters['aPIContactGroupCreationRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIContactGroupCreationRequest',
                'Required parameter "aPIContactGroupCreationRequest" was null or undefined when calling v1ContactsContactsGroupsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/groups/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: APIContactGroupCreationRequestToJSON(requestParameters['aPIContactGroupCreationRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupCreationFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsCreate(requestParameters: V1ContactsContactsGroupsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupCreation> {
        const response = await this.v1ContactsContactsGroupsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsDestroyRaw(requestParameters: V1ContactsContactsGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsGroupsDestroy().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsGroupsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/groups/{id}/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsDestroy(requestParameters: V1ContactsContactsGroupsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.v1ContactsContactsGroupsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsListRaw(requestParameters: V1ContactsContactsGroupsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIPaginatedContactGroupViewList>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsGroupsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/groups/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIPaginatedContactGroupViewListFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsList(requestParameters: V1ContactsContactsGroupsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIPaginatedContactGroupViewList> {
        const response = await this.v1ContactsContactsGroupsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsPartialUpdateRaw(requestParameters: V1ContactsContactsGroupsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupView>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsGroupsPartialUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsGroupsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/groups/{id}/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: APIPatchedContactGroupViewRequestToJSON(requestParameters['aPIPatchedContactGroupViewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupViewFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsPartialUpdate(requestParameters: V1ContactsContactsGroupsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupView> {
        const response = await this.v1ContactsContactsGroupsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsRetrieveRaw(requestParameters: V1ContactsContactsGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupView>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsGroupsRetrieve().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsGroupsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/groups/{id}/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupViewFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsRetrieve(requestParameters: V1ContactsContactsGroupsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupView> {
        const response = await this.v1ContactsContactsGroupsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsUpdateRaw(requestParameters: V1ContactsContactsGroupsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<APIContactGroupView>> {
        if (requestParameters['contactsPk'] == null) {
            throw new runtime.RequiredError(
                'contactsPk',
                'Required parameter "contactsPk" was null or undefined when calling v1ContactsContactsGroupsUpdate().'
            );
        }

        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling v1ContactsContactsGroupsUpdate().'
            );
        }

        if (requestParameters['aPIContactGroupViewRequest'] == null) {
            throw new runtime.RequiredError(
                'aPIContactGroupViewRequest',
                'Required parameter "aPIContactGroupViewRequest" was null or undefined when calling v1ContactsContactsGroupsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/v1/contacts/contacts/{contacts_pk}/groups/{id}/`.replace(`{${"contacts_pk"}}`, encodeURIComponent(String(requestParameters['contactsPk']))).replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: APIContactGroupViewRequestToJSON(requestParameters['aPIContactGroupViewRequest']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => APIContactGroupViewFromJSON(jsonValue));
    }

    /**
     * Mixin to provide support for Serializer Extensions within API views.
     */
    async v1ContactsContactsGroupsUpdate(requestParameters: V1ContactsContactsGroupsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<APIContactGroupView> {
        const response = await this.v1ContactsContactsGroupsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
